import React from 'react';
import classNames from 'classnames';

const Calendar = ({
  prices, conditions, availabilities, displayAvailabilities = true, showDecimals = true,
  scrollLeft, calendarDates, oncClickPrice = null, onClickCondition = null,
}) => {
  return (
    <div>
      <div className="left-column" style={ { left: scrollLeft } }>
        <table>
          {
            displayAvailabilities
              ? <tbody>
                  <tr className="row-prices">
                    <td>Availability</td>
                  </tr>
                </tbody>
              : null
          }
          <tbody>
            <tr className="row-prices">
              <td>Min. stay</td>
            </tr>
            {
              Object.keys(prices).map((key, i) => {
                const [minNights, nbGuests] = key.split('_');
                return (
                  <tr className="row-prices" key={ i }>
                    <td>
                      Min. nights: { minNights }
                      <br/>
                      Nb. guests: { nbGuests }
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
      <div className="calendar-content">
        <table>
          {
            displayAvailabilities
              ? <tbody>
                  <tr className="row-availabilities">
                    {
                      (availabilities || []).map((available, i) => {
                        return (
                          <td key={ i } className={ classNames('cell-availability', { available, unavailable: !available }) } />
                        );
                      })
                    }
                  </tr>
                </tbody>
              : null
          }
          <tbody>
            <tr className="row-min-stay">
              {
                conditions.map((condition, i) => {
                  const isBaseCondition = condition.display_type === 'base';
                  const isSeason = condition.display_type === 'season';
                  const isSeasonAlter = condition.display_type === 'season_alter';
                  return (
                    <td key={ i } onClick={ handleClickCondition.bind(null, condition, onClickCondition) } className={ classNames({ 'cell-min-stay': !isBaseCondition, base: isBaseCondition, season: isSeason, 'season-alter': isSeasonAlter }) }>
                      { condition.min_stay }
                    </td>
                  );
                })
              }
            </tr>
            {
              Object.keys(prices).map((key, i) => {
                const pricesByDate = prices[key];
                return (
                  <tr className="row-prices" key={ i }>
                    {
                      calendarDates.map((date, j) => {
                        let seasonType;
                        const params = pricesByDate[date.stringISO] || null;
                        const isBasePrice = !params || params.display_type === 'base';
                        const isSeason = params && params.display_type === 'season';
                        const isSeasonAlter = params && params.display_type === 'season_alter';
                        const price = (params || {}).price || 0;
                        return (
                          <td key={ j } onClick={ handleClickPrice.bind(null, params, oncClickPrice) } className={ classNames({ 'cell-price': !!params && !!oncClickPrice, base: isBasePrice, season: isSeason, 'season-alter': isSeasonAlter }) }>
                            { showDecimals ? price.toFixed(2) : price }
                          </td>
                        );
                      })
                    }
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

function handleClickPrice(params, oncClickPrice) {
  if (!!params && !!oncClickPrice) oncClickPrice(params);
}
function handleClickCondition(condition, onClickCondition) {
  if (condition.display_type !== 'base' && !!onClickCondition) onClickCondition(condition);
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/Calendar.jsx